export const ALREADY_READ_TERMS_COOKIE = {
    Key: 'AlreadyReadTermsCookie',
    Value: 'true',
    ExpirationDays: 60,
};
